var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { attrs: { "grid-list-md": "", "text-xs-center": "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _vm.categoriaUsuario === "Interno"
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", md3: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.empresas,
                          label: "Seleccionar Empresa",
                          dense: "",
                          clearable: "",
                          "item-text": "nombre",
                          "item-value": "id"
                        },
                        model: {
                          value: _vm.filterField.IdCliente,
                          callback: function($$v) {
                            _vm.$set(_vm.filterField, "IdCliente", $$v)
                          },
                          expression: "filterField.IdCliente"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-flex",
                { attrs: { xs12: "", md3: "" } },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.estados,
                      label: "Seleccionar Estado",
                      dense: "",
                      clearable: "",
                      "item-text": "text",
                      "item-value": "id"
                    },
                    model: {
                      value: _vm.filterField.IdRazo,
                      callback: function($$v) {
                        _vm.$set(_vm.filterField, "IdRazo", $$v)
                      },
                      expression: "filterField.IdRazo"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { xs12: "", md2: "" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "search",
                      label: "Buscar...",
                      dense: ""
                    },
                    model: {
                      value: _vm.filterField.filtroTexto,
                      callback: function($$v) {
                        _vm.$set(_vm.filterField, "filtroTexto", $$v)
                      },
                      expression: "filterField.filtroTexto"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  staticClass: "text-sm-center botones-filtros",
                  attrs: { xs12: "", md1: "" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function($event) {
                          return _vm.$emit("filter", _vm.filterField)
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("search")]),
                      _vm._v("\n          Filtrar\n        ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  staticClass: "text-sm-center botones-filtros",
                  attrs: { xs12: "", md1: "" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "black--text",
                      on: {
                        click: function($event) {
                          return _vm.clearFilter()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("clear")]),
                      _vm._v("\n          Limpiar filtros\n        ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  staticClass: "text-sm-center botones-filtros",
                  attrs: { xs12: "", md1: "" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "black--text",
                      on: {
                        click: function($event) {
                          return _vm.$emit("exportar", true)
                        }
                      }
                    },
                    [
                      _vm._v("\n          Exportar a Excel\n          "),
                      _c("v-icon", { attrs: { right: "", dark: "" } }, [
                        _vm._v("description")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                {
                  staticClass: "text-sm-center botones-filtros",
                  attrs: { xs12: "", md2: "" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "black--text",
                      on: {
                        click: function($event) {
                          _vm.advancedFilters = !_vm.advancedFilters
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { left: "", dark: "" } }, [
                        _vm._v("filter_alt")
                      ]),
                      _vm._v("\n          Filtros avanzados\n        ")
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-spacer"),
              _vm.advancedFilters
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", md3: "" } },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "close-on-content-click": false,
                            "nudge-right": 40,
                            lazy: "",
                            transition: "scale-transition",
                            "offset-y": "",
                            "full-width": "",
                            "min-width": "290px"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-text-field",
                                      _vm._g(
                                        {
                                          attrs: {
                                            label: "Fecha desde",
                                            "prepend-icon": "event",
                                            readonly: ""
                                          },
                                          model: {
                                            value: _vm.filterField.fechadesde,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filterField,
                                                "fechadesde",
                                                $$v
                                              )
                                            },
                                            expression: "filterField.fechadesde"
                                          }
                                        },
                                        on
                                      )
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            449911093
                          ),
                          model: {
                            value: _vm.menu,
                            callback: function($$v) {
                              _vm.menu = $$v
                            },
                            expression: "menu"
                          }
                        },
                        [
                          _c("v-date-picker", {
                            attrs: { "no-title": "" },
                            on: {
                              input: function($event) {
                                _vm.menu = false
                              }
                            },
                            model: {
                              value: _vm.filterField.fechadesde,
                              callback: function($$v) {
                                _vm.$set(_vm.filterField, "fechadesde", $$v)
                              },
                              expression: "filterField.fechadesde"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.advancedFilters
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", md3: "" } },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "close-on-content-click": false,
                            "nudge-right": 40,
                            lazy: "",
                            transition: "scale-transition",
                            "offset-y": "",
                            "full-width": "",
                            "min-width": "290px"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-text-field",
                                      _vm._g(
                                        {
                                          attrs: {
                                            label: "Fecha Hasta",
                                            "prepend-icon": "event",
                                            readonly: ""
                                          },
                                          model: {
                                            value: _vm.filterField.fechahasta,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filterField,
                                                "fechahasta",
                                                $$v
                                              )
                                            },
                                            expression: "filterField.fechahasta"
                                          }
                                        },
                                        on
                                      )
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3224702613
                          ),
                          model: {
                            value: _vm.menu2,
                            callback: function($$v) {
                              _vm.menu2 = $$v
                            },
                            expression: "menu2"
                          }
                        },
                        [
                          _c("v-date-picker", {
                            attrs: { "no-title": "" },
                            on: {
                              input: function($event) {
                                _vm.menu2 = false
                              }
                            },
                            model: {
                              value: _vm.filterField.fechahasta,
                              callback: function($$v) {
                                _vm.$set(_vm.filterField, "fechahasta", $$v)
                              },
                              expression: "filterField.fechahasta"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.advancedFilters
                ? _c(
                    "v-flex",
                    { attrs: { xs12: "", md3: "" } },
                    [
                      _c("v-select", {
                        attrs: {
                          items: _vm.categorias,
                          label: "Categoría",
                          "item-text": "nombre",
                          "item-value": "id",
                          dense: "",
                          clearable: ""
                        },
                        model: {
                          value: _vm.filterField.IdCategoria,
                          callback: function($$v) {
                            _vm.$set(_vm.filterField, "IdCategoria", $$v)
                          },
                          expression: "filterField.IdCategoria"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm.showDialog
        ? _c("mis-solicitudes-export-dialog", {
            attrs: { dialog: _vm.showDialog },
            on: {
              close: function($event) {
                return _vm.closeDialog($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }